import { createAuthClient } from "better-auth/react";
import { jwtClient } from "better-auth/client/plugins";

import { publicEnv } from "../env";
import { applyAuthLocaleHeader } from "@/i18n/request-locale";

const authClientOptions = {
  baseURL: publicEnv.apiUrl,
  fetchOptions: {
    onRequest: applyAuthLocaleHeader,
  },
  plugins: [jwtClient()],
  // Match React Query: avoid focus/visibility thrash refetching get-session.
  sessionOptions: {
    refetchOnWindowFocus: false,
  },
};

/** 与 FC `/api/auth/*` 通信的 Better Auth React 客户端。 */
// Better Auth 1.6.25 的生成声明回归；修复后此 expect-error 会主动失效。
// https://github.com/better-auth/better-auth/issues/10789
// @ts-expect-error jwtClient runtime contract matches the documented client plugin API.
export const authClient = createAuthClient<typeof authClientOptions>(
  authClientOptions,
);
